<template>
  <v-card flat>
    <div class="col-md-12">
      <table class="table table-bordered">
        <thead>
        <tr>
          <td>Vehicle Category</td>
          <td>Currency</td>
          <td>Amount</td>
          <td>Vehicles</td>
          <td v-if="route !== 'NewPartnerBooking'">Discount (%)</td>
          <td v-if="route !== 'NewPartnerBooking'">Discount Reason</td>
          <td>Total Amount</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(vehicle, key) in allVehicles" :key="key">
          <td>{{vehicle.vehicle_charge_category}}</td>
          <td>{{currency}}</td>
          <td>{{$roundOff((convert1(vehicle.vehicle_charge_cost_currency, vehicle.vehicle_charge_category_cost).amount).toFixed(2))}}</td>

          <td v-if="route === 'PostponeBooking'"><v-text-field label="Number" min="0" v-model="allVehicles[key].vehicles"   :disabled="true" type="number"></v-text-field></td>
          
          <td v-else><v-text-field label="Number" min="0" v-model="allVehicles[key].vehicles" type="number"></v-text-field></td>
      
          <td v-if="route === 'PostponeBooking'"><v-text-field label="Discount (%)" min="0" max="100" :rules="limitRules" type="number" v-model="allVehicles[key].discount"  :disabled="true"></v-text-field></td>

          <td v-else-if="route !== 'NewPartnerBooking'"><v-text-field label="Discount (%)" min="0" max="100" :rules="limitRules" type="number" v-model="allVehicles[key].discount"></v-text-field></td>

          <td v-if="route === 'PostponeBooking'"><v-text-field label="Discount Reason" v-model="allVehicles[key].reason" :disabled="true"  required></v-text-field></td>
          <td v-else-if="route !== 'NewPartnerBooking'"><v-text-field label="Discount Reason" v-model="allVehicles[key].reason" required></v-text-field></td>
<!--          <td><b>{{$localCurrency}} {{$roundOff(convert1(vehicle.vehicle_charge_cost_currency, allVehicles[key].vehicle_charge_category_cost * allVehicles[key].vehicles * ((100 - allVehicles[key].discount) / 100)).amount)}}</b></td>-->
          <td><b>{{$localCurrency}} {{Math.ceil(allVehicles[key].vehicles * ((100 - allVehicles[key].discount) / 100) * Math.round(convert1(vehicle.vehicle_charge_cost_currency, allVehicles[key].vehicle_charge_category_cost).amount))}}</b></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td  v-if="route !== 'NewPartnerBooking'"></td>
          <td  v-if="route !== 'NewPartnerBooking'"></td>
          <td></td>
          <td><h3><b>{{$localCurrency}} {{vehicleTotal}}</b></h3></td>
        </tr>
        </tbody>
      </table>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'vehicle-fees',
  props: ['check_in', 'check_out'],
  data () {
    return {
      limitRules: [
        v => v < 101 || 'Discount cannot be more than 100%'
      ],
      route: this.$route.name,
      gate_pass: {
        check_in: this.check_in,
        check_out: this.check_out
      }
    }
  },
  computed: {
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency
    }
  },
  created () {
    if (this.$route.name !== 'NewBooking') {
      this.$store.dispatch('get_all_vehicle_fees')
    }
  }
}
</script>

<style scoped>

</style>
